import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios/index';
import globalFunctions from '../helpers/globalFunctions';
import QueryString from "query-string";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        authStorage: null,
        userName: "",
        classificationPlan: [],
        statusPageActiveTab: 'map',
        classificationPlanFiltered: [],
        classificationPlanFilteredAndChecked: [],
        classificationPlanDeletedClasses: [],
        moves: [],
        filters: {
            label: "none", labelName: "none", povezaniSistemi: "none", rokHrambe: "none",
            vrstaGradiva: "none", vpisnik: "none", creationDate: {start: null, end: null}, usageEndDate: {
                start: null, end: null
            }
        },
        selectedClass: {},
        registerOptions: [],
        connectedSystemsOptions: [],
        storageDateOptions: [],
        documentTypeOptions: [],
        allMetadataOptions: [],
        alfrescoDictionary: null,
        eHrambaAlfrescoDictionary: null,
        classificationPlanSessionHash: null,
        keyCloakData: null,
        offsetTop: null,
        permissions: {},
        metadataSearchValues: {},
        selectedDocuments: [],
        reportTypeOptions: [],
        codeListProperties: [],
        itemsPerPage: 10,
        cancelTokens: [],
        activeNode: null,
        activeNodeContent: null
    },
    mutations: {

        SET_REGISTER_OPTIONS(state, payload) {
            console.log("SET_REGISTER_OPTIONS payload", payload);
            Vue.set(state, 'registerOptions', payload);
        },

        SET_CODE_LIST_PROPERTIES(state, payload) {
            console.log("SET_CODE_LIST_PROPERTIES payload", payload);
            Vue.set(state, 'codeListProperties', payload);
        },

        SET_CONNECTED_SYSTEMS_OPTIONS(state, payload) {
            console.log("SET_CONNECTED_SYSTEMS_OPTIONS payload", payload);
            Vue.set(state, 'connectedSystemsOptions', payload);
        },

        SET_STORAGE_DATE_OPTIONS(state, payload) {
            console.log("SET_STORAGE_DATE_OPTIONS payload", payload);
            Vue.set(state, 'storageDateOptions', payload);
        },

        SET_DOCUMENT_TYPE_OPTIONS(state, payload) {
            console.log("SET_DOCUMENT_TYPE_OPTIONS payload", payload);
            Vue.set(state, 'documentTypeOptions', payload);
        },

        SET_ALL_METADATA_OPTIONS(state, payload) {
            console.log("SET_ALL_METADATA_OPTIONS payload", payload);
            Vue.set(state, 'allMetadataOptions', payload);
        },

        RETRIEVE_USER_NAME(state, payload) {
            console.log("RETRIEVE_USER_NAME payload", payload);
            Vue.set(state, 'userName', payload);
        },

        RETRIEVE_ALFRESCO_DICTIONARY(state, payload) {
            console.log("RETRIEVE_ALFRESCO_DICTIONARY payload", payload);
            Vue.set(state, 'alfrescoDictionary', payload);
        },

        RETRIEVE_EHRAMBA_ALFRESCO_DICTIONARY(state, payload) {
            console.log("RETRIEVE_EHRAMBA_ALFRESCO_DICTIONARY payload", payload);
            Vue.set(state, 'eHrambaAlfrescoDictionary', payload);
        },


        SET_CLASSIFICATION_PLAN(state, payload) {
            console.log("SET_CLASSIFICATION_PLAN payload", payload);
            Vue.set(state, 'classificationPlan', payload);
        },

        SET_STATUS_PAGE_ACTIVE_TAB(state, activeTab) {
            console.log("SET_STATUS_PAGE_ACTIVE_TAB payload", activeTab);
            Vue.set(state, 'statusPageActiveTab', activeTab);
        },
        SET_CLASSIFICATION_PLAN_FILTERED(state, payload) {
            //console.log("SET CLASSIFICATION_PLAN_FILTERED", payload);
            Vue.set(state, 'classificationPlanFiltered', payload);
        },

        SET_CLASSIFICATION_PLAN_FILTERED_AND_CHECKED(state, payload) {
            console.log("SET CLASSIFICATION_PLAN_FILTERED_AND_CHECKED", payload);
            Vue.set(state, 'classificationPlanFilteredAndChecked', payload);
        },

        ADD_CLASSIFICATION_PLAN_DELETED_CLASS(state, uuid) {
            state.classificationPlanDeletedClasses.push(uuid);
        },

        CLEAR_CLASSIFICATION_PLAN_DELETED_CLASS(state) {
            Vue.set(state, 'classificationPlanDeletedClasses', []);
        },

        SET_FILTERS(state, payload) {
            //console.log("SET FILTERS", payload);
            Vue.set(state, "filters", payload);
        },

        SET_SELECTED_CLASS(state, payload) {
            //console.log("SET FILTERS", payload);
            Vue.set(state, "filters", payload);
        },

        SET_MOVES(state, payload) {
            console.log("SET_MOVES", payload);
            Vue.set(state, "moves", payload);
        },

        SET_CLASSIFICATION_PLAN_SESSION_HASH(state, payload) {
            console.log("SET_CLASSIFICATION_PLAN_SESSION_HASH", payload);
            Vue.set(state, "classificationPlanSessionHash", payload);
        },

        SET_OFFSET_TOP(state, payload) {
            console.log("SET_OFFSET_TOP", payload);
            Vue.set(state, "offsetTop", payload);
        },

        SET_PERMISSIONS(state, payload) {
            console.log("SET_PERMISSIONS", payload);
            Vue.set(state, "permissions", payload);
        },

        SET_METADATA_SEARCH_VALUES(state, payload) {
            console.log("SET_METADATA_SEARCH_VALUES", payload);
            Vue.set(state, "metadataSearchValues", payload);
        },

        SET_SELECTED_DOCUMENTS(state, payload) {
            console.log("SET_SELECTED_DOCUMENTS", payload);
            Vue.set(state, "selectedDocuments", payload);
        },

        SET_REPORT_TYPE_OPTIONS(state, payload) {
            console.log("SET_REPORT_TYPE_OPTIONS payload", payload);
            Vue.set(state, 'reportTypeOptions', payload);
        },

        SET_ITEMS_PER_PAGE(state, payload) {
            console.log("SET_ITEMS_PER_PAGE payload", payload);
            Vue.set(state, 'itemsPerPage', payload);
        },

        ADD_CANCEL_TOKEN(state, token) {
            state.cancelTokens.push(token);
        },
        CLEAR_CANCEL_TOKENS(state) {
            state.cancelTokens = [];
        },

        SET_ACTIVE_NODE(state, payload) {
            console.log("SET_ACTIVE_NODE payload", payload);
            Vue.set(state, 'activeNode', payload);
        },

        SET_ACTIVE_NODE_CONTENT(state, payload) {
            console.log("SET_ACTIVE_NODE payload", payload);
            Vue.set(state, 'activeNodeContent', payload);
        },

        RESET_STORE(state) {
            console.log("RESET_STORE");
            Vue.set(state, "authStorage", null);
            Vue.set(state, "userDetails", {});
            Vue.set(state, "alfrescoDictionary", null);
            Vue.set(state, "classificationPlan", []);
            Vue.set(state, "statusPageActiveTab", 'map');
            Vue.set(state, "classificationPlanFiltered", []);
            Vue.set(state, "classificationPlanFilteredAndChecked", []);
            Vue.set(state, "moves", []);
            Vue.set(state, "filters", {
                label: "none",
                labelName: "none",
                povezaniSistemi: "none",
                rokHrambe: "none",
                vrstaGradiva: "none",
                vpisnik: "none",
                creationDate: "none",
                usageEndDate: "none"
            });
            Vue.set(state, "selectedClass", {});
            Vue.set(state, "registerOptions", []);
            Vue.set(state, "connectedSystemsOptions", []);
            Vue.set(state, "storageDateOptions", []);
            Vue.set(state, "documentTypeOptions", []);
            Vue.set(state, "offsetTop", null);
            Vue.set(state, "permissions", {});
            Vue.set(state, "metadataSearchValues", {});
            Vue.set(state, "userName", "");
            Vue.set(state, "selectedDocuments", []);
        }

    },
    actions: {

        async retrieveUserDetails(context) {

            await axios.get(config.codeLists + 'permissions')
                .then((res) => {
                    context.commit("RETRIEVE_USER_NAME", res.data.body.username);
                })
                .catch((error) => {
                    console.error(error);
                });
        },


        async retrieveAlfrescoDictionary(context, forceUpdate) {

            console.log("trying to retrieve alfresco dictionary");


            // do ajax call only if dictionary
            if (this.state.alfrescoDictionary && !forceUpdate) {
                console.log("Alfresco Dictionary already in store!");
                return;
            }

            await axios.get(config.alfrescoDictionary)
                .then((res) => {
                    let dictionaryData = _.filter(res.data, {'isAspect': true});
                    context.commit("RETRIEVE_ALFRESCO_DICTIONARY", dictionaryData);

                    let eHrambaDictionaryData = _.filter(res.data, function (dictionaryEntry) {
                        if (dictionaryEntry.name.startsWith("EH")) {
                            return dictionaryEntry;
                        }
                    });
                    context.commit("RETRIEVE_EHRAMBA_ALFRESCO_DICTIONARY", eHrambaDictionaryData);
                    console.log("eHrambaDictionaryData - OLD", eHrambaDictionaryData);

                })
                .catch((error) => {
                    console.error(error);
                });
        },

        async retrieveCodeListProperties(context) {

            await axios.get(config.codeLists + 'properties')
                .then((res) => {

                    // set_register
                    context.commit("SET_CODE_LIST_PROPERTIES", res.data.body);
                    console.log(res.data.body);
                    //
                    // let eHrambaDictionaryData = [];
                    // _.map(res.data.body, function (item) {
                    //     if(item.aspect.startsWith("EH") && !_.some(eHrambaDictionaryData, function (topic) {
                    //         return topic.aspect === item.aspect;
                    //     })){
                    //         eHrambaDictionaryData.push({
                    //             aspect: item.aspect,
                    //             name: item.name,
                    //             title: item.name
                    //         });
                    //     }
                    // });
                    // context.commit("RETRIEVE_EHRAMBA_ALFRESCO_DICTIONARY", eHrambaDictionaryData);
                    // console.log("eHrambaDictionaryData - new", eHrambaDictionaryData);

                })
                .catch((error) => {
                    console.error(error);
                });

        },

        async retrieveAllDropdownOptions(context) {

            await axios.get(config.codeLists + 'register')
                .then((res) => {

                    // set_register
                    context.commit("SET_REGISTER_OPTIONS", res.data.body);
                    console.log(res.data.body);

                })
                .catch((error) => {
                    console.error(error);
                });


            await axios.get(config.codeLists + 'connected-system')
                .then((res) => {

                    // set_connected_system
                    context.commit("SET_CONNECTED_SYSTEMS_OPTIONS", res.data.body);
                    console.log(res.data.body);

                })
                .catch((error) => {
                    console.error(error);
                });


            await axios.get(config.codeLists + 'storage-date')
                .then((res) => {

                    // set_storage_date
                    context.commit("SET_STORAGE_DATE_OPTIONS", res.data.body);
                    console.log(res.data.body);

                })
                .catch((error) => {
                    console.error(error);
                });

            await axios.get(config.codeLists + 'document-type')
                .then((res) => {

                    // set_storage_date
                    context.commit("SET_DOCUMENT_TYPE_OPTIONS", res.data.body);
                    console.log(res.data.body);

                })
                .catch((error) => {
                    console.error(error);
                });

        },

        async retrieveAllMetadataOptions(context) {

            if(this.state.allMetadataOptions.length > 0) {
                return;
            }
            await axios.get(config.codeLists + 'all')
                .then(async (res) => {
                    // set_register
                    let items = res.data && res.data.body ? res.data.body : [];

                    _.map(items, function (item, idx) {
                        item.body = _.sortBy(item.body,
                            function (o) {
                                if (o.description) {
                                    return o.description;
                                } else if (o.name) {
                                    return o.name;
                                }
                            });
                    });

                    await context.commit("SET_ALL_METADATA_OPTIONS", items);
                })
                .catch((error) => {
                    console.error(error);
                });

        },

        async retrievePermissions(context) {

            if(this.state.permissions.length > 0) {
                return;
            }

            await axios.get(config.codeLists + 'permissions')
                .then((res) => {

                    if(res.data && res.data.body) {
                        console.log("SET_PERMISSIONS", res.data.body.roles);
                        context.commit("SET_PERMISSIONS", res.data.body.roles);
                    }

                })
                .catch((error) => {
                    console.error(error);
                });
        },

        setClassificationPlan(context, classificationPlan) {
            console.log("SET_CLASSIFICATION_PLAN", classificationPlan);
            context.commit("SET_CLASSIFICATION_PLAN", classificationPlan);
        },

        setStatusPageActiveTab(context, activeTab) {
            console.log("setStatusPageActiveTab", activeTab);
            context.commit("SET_STATUS_PAGE_ACTIVE_TAB", activeTab);
        },

        setClassificationPlanFiltered(context, classificationPlan) {
            //console.log("SET_CLASSIFICATION_PLAN_FILTERED", classificationPlan);
            context.commit("SET_CLASSIFICATION_PLAN_FILTERED", classificationPlan);
        },

        setFilters(context, filters) {
            //console.log("SET_FILTERS", filters);
            context.commit("SET_FILTERS", filters);
        },

        setClassificationPlanFilteredAndChecked(context, classificationPlan) {
            console.log("SET_CLASSIFICATION_PLAN_FILTERED_AND_CHECKED", classificationPlan);
            context.commit("SET_CLASSIFICATION_PLAN_FILTERED_AND_CHECKED", classificationPlan);
        },

        addClassificationPlanDeletedClass(context, uuid) {
            console.log("ADD_CLASSIFICATION_PLAN_DELETED_CLASS", uuid);
            context.commit("ADD_CLASSIFICATION_PLAN_DELETED_CLASS", uuid);
        },

        clearClassificationPlanDeletedClass(context) {
            console.log("CLEAR_CLASSIFICATION_PLAN_DELETED_CLASS");
            context.commit("CLEAR_CLASSIFICATION_PLAN_DELETED_CLASS");
        },

        setSelectedClass(context, classificationPlan) {
            console.log("SET_CLASSIFICATION_PLAN_FILTERED_AND_CHECKED", classificationPlan);
            context.commit("SET_SELECTED_CLASS", classificationPlan);
        },

        setMoves(context, moves) {
            console.log("SET_MOVES", moves);
            context.commit("SET_MOVES", moves);
        },

        setClassificationPlanSessionHash(context, hash) {
            context.commit("SET_CLASSIFICATION_PLAN_SESSION_HASH", hash);
        },

        setOffsetTop(context, offsetTop) {
            context.commit("SET_OFFSET_TOP", offsetTop);
        },

        setMetadataSearchValues(context, values) {
            context.commit("SET_METADATA_SEARCH_VALUES", values);
        },

        resetStore(context) {
            context.commit("RESET_STORE");
        },

        setSelectedDocuments(context, data) {
            context.commit("SET_SELECTED_DOCUMENTS", data);
        },

        async retrieveReportTypeOptions(context) {
            if(this.state.reportTypeOptions.length > 0) {
                return;
            }

            await axios.get(config.codeLists + 'report')
                .then((res) => {
                    if(res.data && res.data.body) {
                        context.commit("SET_REPORT_TYPE_OPTIONS", res.data.body);
                        console.log(res.data.body);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        async downloadAttachment(context, parameters) {
            const _this = this;
            await axios.get(config.alfrescoCoreApi + 'nodes/' + parameters.nodeId + '/content?attachment=true', {
                method: 'GET',
                responseType: 'blob' //Force to receive data in a Blob Format
            })

                .then((res) => {

                    const url = window.URL.createObjectURL(globalFunctions.blobToFile(res.data, parameters.filename));

                    let link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', parameters.filename);
                    link.setAttribute('type', parameters.mimetype);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                })
                .catch((error) => {
                    console.error(error);
                });

        },

        setItemsPerPage(context, data) {
            context.commit("SET_ITEMS_PER_PAGE", data);
        },

        cancelPendingRequests(context) {

            // Cancel all request where a token exists
            context.state.cancelTokens.forEach((request, i) => {
                if(request.cancel){
                    request.cancel();
                }
            });

            // Reset the cancelTokens store
            context.commit('CLEAR_CANCEL_TOKENS');
        },


        setActiveNode(context, data) {
            context.commit("SET_ACTIVE_NODE", data);
        },

        setActiveNodeContent(context, data) {
            context.commit("SET_ACTIVE_NODE_CONTENT", data);

            // await axios.get(config.alfrescoCoreApi + 'nodes/' + data.id + '/children')
            //     .then((res) => {
            //         context.commit("SET_ACTIVE_NODE_CONTENT", res.data.list.entries);
            //     })
            //     .catch((error) => {
            //         console.error(error);
            //     });
        },
    },
    getters: {
        getUserName: state => state.userName,
        getAlfrescoDictionary: state => state.alfrescoDictionary,
        getCodeListProperties: state => state.codeListProperties,
        geteHrambaAlfrescoDictionary: state => state.eHrambaAlfrescoDictionary,
        getClassificationPlan: state => state.classificationPlan,
        getStatusPageActiveTab: state => state.statusPageActiveTab,
        getClassificationPlanFiltered: state => state.classificationPlanFiltered,
        getClassificationPlanFilteredAndChecked: state => state.classificationPlanFilteredAndChecked,
        getClassificationPlanDeletedClasses: state => state.classificationPlanDeletedClasses,
        getFilters: state => state.filters,
        getSelectedClass: state => state.selectedClass,
        getMoves: state => state.moves,
        getRegisterOptions: state => state.registerOptions,
        getConnectedSystemsOptions: state => state.connectedSystemsOptions,
        getStorageDateOptions: state => state.storageDateOptions,
        getDocumentTypeOptions: state => state.documentTypeOptions,
        getAllMetadataOptions: state => state.allMetadataOptions,
        getClassificationPlanSessionHash: state => state.classificationPlanSessionHash,
        getOffsetTop: state => state.offsetTop,
        getPermissions: state => state.permissions,
        getMetadataSearchValues: state => state.metadataSearchValues,
        getSelectedDocuments: state => state.selectedDocuments,
        getReportTypeOptions: state => state.reportTypeOptions,
        getItemsPerPage: state => state.itemsPerPage,
        cancelTokens: state => state.cancelTokens,
        getActiveNode: state => state.activeNode,
        getActiveNodeContent: state => state.activeNodeContent
    }
});



// WEBPACK FOOTER //
// ./src/store/store.js